
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snorapport",
      function () {
        return require("private-next-pages/[region]/[resort]/snorapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snorapport"])
      });
    }
  